import { Divider, Space } from 'antd';
import clx from 'classnames';
import { down } from 'styled-breakpoints';
import styled, { useTheme } from 'styled-components';

const StyledLogoImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;

  border: none;
  margin: 0;
  padding: 0;
`;

const LogoWrapper = styled.div`
  width: 185px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: start;

  ${down('md')} {
    width: 123px;
    height: 40px;
  }
`;
const TextWrapper = styled.div`
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
  ${down('md')} {
    font-size: 1.5rem;
  }
  ${down('sm')} {
    font-size: 1.2rem;
  }
  @media (max-width: 400px) {
    display: none;
  }
`;
const StyledWrapperSpace = styled(Space)`
  display: flex;
  align-items: center;
  line-height: 1;
  &.clickable {
    cursor: pointer;
  }
  gap: 30px;
  ${down('sm')} {
    gap: 10px;
  }
`;
const LogoDivider = styled(Divider)`
  height: 60px;
  ${down('md')} {
    height: 40px;
  }
  ${down('sm')} {
    display: none;
  }
`;
export interface IFrontHeaderLogoProps {
  onClick?: () => void;
}

/**
 * Logo principale dell'applicativo.
 */
export function FrontHeaderLogo(props: IFrontHeaderLogoProps) {
  const theme = useTheme();
  const hasClick = !!props.onClick;

  return (
    <StyledWrapperSpace
      onClick={props.onClick}
      className={clx({ clickable: hasClick })}
    >
      <LogoWrapper>
        <StyledLogoImg src={theme.logoUrlDark} alt={theme.logoAltText} />
      </LogoWrapper>
      <LogoDivider type="vertical" aria-hidden="true" />
      <Space direction="vertical" size={0}>
        <TextWrapper>{theme.logoFrontName}</TextWrapper>
      </Space>
    </StyledWrapperSpace>
  );
}
